import {
  ButtonV3,
  GridItem,
  LayoutGrid,
  TypographyV3,
} from '@jouzen/ecom-components';
import { AnimatePresence } from 'framer-motion';
import { useTranslations } from 'next-intl';
import { useRef, useState } from 'react';

import Section from '@/app/components/LegacyLandingPage/components/Section';
import Motion from '@/app/components/Motion';

import CareerDetails from './CareerDetails';
import CareersList from './CareersList';
import type { Job } from './types';

const CareersJobBoard = () => {
  const [department, setDepartment] = useState<string | null>(null);
  const [detailList, setDetailList] = useState<Job[] | null>(null);
  const topOfComponentRef = useRef<HTMLDivElement>(null);
  const t = useTranslations();

  const handleSetDetailView = (dept: string, jobs: Job[]) => {
    setDepartment(dept);
    setDetailList(jobs);
    topOfComponentRef.current?.scrollIntoView();
  };

  const handleClearDetails = () => setDetailList(null);

  return (
    <Section data-cy="careers-job-board">
      <div id="open-positions" ref={topOfComponentRef} />
      <LayoutGrid>
        <TypographyV3
          variant="h1"
          weight="light"
          className="col-main w-3/4 md:w-full"
        >
          {t('ready_when_you_are')}
        </TypographyV3>
      </LayoutGrid>

      <LayoutGrid>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <ButtonV3
            target="_blank"
            className="my-8"
            href="https://apply.workable.com/oura-health-ltd/"
            rel="nofollow"
            variant="secondary-dark"
          >
            {t('see_all_positions')}
          </ButtonV3>
        </GridItem>
      </LayoutGrid>

      <LayoutGrid>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <AnimatePresence initial={false} mode="wait">
            {detailList ? (
              <Motion
                key="details"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.2 }}
              >
                <CareerDetails
                  department={department}
                  details={detailList}
                  clearDetails={handleClearDetails}
                />
              </Motion>
            ) : (
              <Motion
                key="list"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.2 }}
              >
                <CareersList setDetailView={handleSetDetailView} />
              </Motion>
            )}
          </AnimatePresence>
        </GridItem>
      </LayoutGrid>
    </Section>
  );
};

export default CareersJobBoard;
